import { intersectionBy } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { TabGroup } from 'web-ui-components/lib/navigation/tab-group';
import { paymentTypeTabs } from '../config/index';
import { getAllVisiblePaymentTabs } from '../states/capabilities/selectors';

const mapState = (state) => ({
	visibleTabIds: getAllVisiblePaymentTabs(state),
});
export const buildPaymentTabs = (visibleTabIds) => intersectionBy(paymentTypeTabs, visibleTabIds, 'id');
export const PaymentTabs = ({ visibleTabIds, handleSelectTab, activeTab }) => (
	<TabGroup activeTab={activeTab} onChange={handleSelectTab} tabButtons={buildPaymentTabs(visibleTabIds)} />
);

PaymentTabs.propTypes = {
	handleSelectTab: PropTypes.func.isRequired,
	activeTab: PropTypes.string.isRequired,
	visibleTabIds: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.string.isRequired,
		})
	),
};

export default connect(mapState)(PaymentTabs);
